import { Icon } from "../../icons";
import { Brand } from "../Brand/Brand";
import { IconButton } from "../IconButton/IconButton";
import { ThemeToggle } from "../ThemeToggle/ThemeToggle";
import { TopbarNotifications } from "./TopbarNotifications";
import { TopbarSearch } from "./TopbarSearch";
import { TopbarUserMenu } from "./TopbarUserMenu";
import type { NotificationItem, TopbarUser } from "./topbarTypes";

export type { Crumb, NotificationItem, TopbarUser } from "./topbarTypes";

export interface TopbarProps {
  user?: TopbarUser;
  product?: string;
  onHome?: () => void;
  onMenu?: () => void;
  /** Opens the command palette, optionally seeded with what the user started typing. */
  onSearch?: (initialQuery?: string) => void;
  onLogout?: () => void;
  onProfile?: () => void;
  notifications?: NotificationItem[];
  /** Brand area width follows the sidebar (expanded / collapsed). */
  sidebarCollapsed?: boolean;
}

const DEFAULT_USER: TopbarUser = { name: "User" };

/** Full-width header: brand (sidebar-aligned), search, notifications, theme, user menu. */
export function Topbar({
  user = DEFAULT_USER,
  product,
  onHome,
  onMenu,
  onSearch,
  onLogout,
  onProfile,
  notifications = [],
  sidebarCollapsed,
}: TopbarProps): React.JSX.Element {
  return (
    <header className={`nb-topbar${sidebarCollapsed ? " is-collapsed" : ""}`}>
      <div className="nb-top-brand">
        <button type="button" className="nb-icon-btn nb-menu-toggle" aria-label="Open menu" onClick={onMenu}>
          <Icon name="menu" />
        </button>
        <Brand product={product} onHome={onHome} compact={sidebarCollapsed} />
      </div>
      <div className="nb-top-center">
        <TopbarSearch onSearch={onSearch} />
      </div>
      <div className="nb-top-actions">
        <IconButton icon="search" label="Search the suite" className="nb-top-search-icon" onClick={() => onSearch?.()} />
        <span className="nb-top-desktop">
          <TopbarNotifications items={notifications} />
          <ThemeToggle />
        </span>
        <span className="nb-top-sep" aria-hidden="true" />
        <TopbarUserMenu user={user} onProfile={onProfile} onLogout={onLogout} />
      </div>
    </header>
  );
}
